import * as React from "react"
import { cn } from "@verlo/shared/lib/utils"
import { tone } from "@verlo/shared/lib/tones"

/**
 * A status word: `late 23 min`, `allergy`, `seated`, `confirmed`. The one place a signal
 * tint is used — a small uppercase Manrope word with a dot, in the tone's ink on its tint.
 *
 * Replaces the hand-made `bg-signal-warn-tint text-signal-warn rounded-full` spans on table cards,
 * booking cards, order lines and the KDS. No icon: the word is the icon.
 *
 *   <Signal tone="warn">late 23 min</Signal>
 *   <Signal tone="stop" dot={false}>allergy</Signal>
 */
const Signal = React.forwardRef(({ tone: name = "info", dot = true, className, children, ...props }, ref) => {
  const t = tone(name)
  return (
    <span
      ref={ref}
      data-tone={name}
      className={cn(
        "inline-flex items-center gap-1.5 border px-2 py-1 font-heading text-[10.5px] font-bold uppercase leading-none tracking-[0.05em]",
        t.chip,
        className,
      )}
      {...props}
    >
      {dot && <i aria-hidden className={cn("h-1.5 w-1.5 shrink-0", t.dot)} />}
      {children}
    </span>
  )
})
Signal.displayName = "Signal"

export { Signal }
